import { createContext, type ReactNode, useContext, useMemo } from "react";
import { SearchPageType } from "../models/SearchPageType";
import { getSearchPageType, isPlpForSeries } from "../utils/searchPageUtils";

interface ContextData {
  pageType: SearchPageType;
  isPlpForSeries: boolean;
}

const SearchPageTypeContext = createContext<ContextData>({
  pageType: SearchPageType.Unknown,
  isPlpForSeries: false,
});

export const useSearchPageType = () => {
  return useContext(SearchPageTypeContext).pageType;
};

export const SearchPageTypeProvider = ({
  children,
  overrideType,
}: {
  children: ReactNode;
  overrideType?: SearchPageType;
}) => {
  const data = useMemo(() => {
    return {
      pageType: overrideType ?? getSearchPageType(),
      isPlpForSeries: isPlpForSeries(),
    };
  }, [overrideType]);

  return <SearchPageTypeContext.Provider value={data}>{children}</SearchPageTypeContext.Provider>;
};
